(() => {
  const STORAGE_KEY = 'scp_state';

  if (customElements.get('sale-coupon-popup')) return;

  class SaleCouponPopup extends HTMLElement {
    constructor() {
      super();

      this._overlay = null;
      this._panel = null;
      this._closeBtn = null;
      this._copyBtn = null;
      this._couponEl = null;

      this._autoHideTimer = null;
      this._closeDelayOnSwipeOutsideClickSec = null;
      this._copyResetTimer = null;
      this._sessionInterval = null;

      this._isOpen = false;
      this._previousActiveElement = null;

      this._touchStartY = 0;
      this._touchStartX = 0;

      this._clevertapEventName = '';

      this._onOverlayClick = this._onOverlayClick.bind(this);
      this._onCloseClick = this._onCloseClick.bind(this);
      this._onCopyClick = this._onCopyClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onTransitionEnd = this._onTransitionEnd.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onVariantAdded = this._onVariantAdded.bind(this);
      this._clevertapEventData = {
        "Customer Name": 'NA',
        "Customer Email": 'NA',
        "Customer Phone": 'NA',
        "Coupon Code": ''
      };
    }

    connectedCallback() {
      this._overlay = this.querySelector('.scp__overlay');
      this._swipeIndicator = this.querySelector('.scp__swipe-indicator');
      this._panel = this.querySelector('.scp__content-container');
      this._closeBtn = this.querySelector('.scp__close-button');
      this._copyBtn = this.querySelector('.scp__coupon-code-copy-button');
      this._couponEl = this.querySelector('.scp__coupon-code');

      if (!this._overlay || !this._panel) return;

      this._readDataAttributes();
      this._initSessionState();
      this._startSessionInterval();

      this._overlay.hidden = true;
      this._overlay.inert = true;
      this._overlay.setAttribute('aria-hidden', 'true');

      this._closeBtn?.addEventListener('click', this._onCloseClick);
      this._copyBtn?.addEventListener('click', this._onCopyClick);
      
      this._panel.addEventListener('transitionend', this._onTransitionEnd);
      document.removeEventListener('variant:added', this._onVariantAdded);
      document.addEventListener('variant:added', this._onVariantAdded);
    }

    disconnectedCallback() {
      this._overlay.removeEventListener('click', this._onOverlayClick);
      this._closeBtn?.removeEventListener('click', this._onCloseClick);
      this._copyBtn?.removeEventListener('click', this._onCopyClick);

      this._panel.removeEventListener('transitionend', this._onTransitionEnd);
      this._panel.removeEventListener('touchstart', this._onTouchStart);
      this._panel.removeEventListener('touchend', this._onTouchEnd);

      document.removeEventListener('keydown', this._onKeydown);
      document.removeEventListener('variant:added', this._onVariantAdded);
      if (this._sessionInterval !== null) {
        clearInterval(this._sessionInterval);
        this._sessionInterval = null;
      }
      if (this._delayedInteractionListenerTimer) {
        clearTimeout(this._delayedInteractionListenerTimer);
        this._delayedInteractionListenerTimer = null;
      }
      this._clearPopupTimers();
    }

    _onVariantAdded(e) {
      if (this._sessionInterval !== null) {
        this._state.product_added_to_cart = true;
        this._persistState();
        clearInterval(this._sessionInterval);
        this._sessionInterval = null;
      }
    }


    _readDataAttributes() {
      const d = this.dataset;

      this._data = {
        auto_hide: Math.max(0, Number(d.autoHideInSeconds || 0)),
        close_delay_on_swipe_outside_click_sec: Math.max(0, Number(d.closeDelayOnSwipeOutsideClickSec || 0)),
        session_duration: Math.max(1, Number(d.userSessionDurationInSeconds || 0)),
        verify_url: (d.verifyUrl || '').trim(),
        coupon_code: (d.couponCode || '').trim(),
        customer_id: (d.customerId || '').trim(),
        customer_email: (d.customerEmail || '').trim(),
        customer_name: (d.customerName || '').trim(),
        customer_phone: (d.customerPhoneNumber || '').trim()
      };

      this._clevertapEventName = (d.clevertapEventName || '').trim();
    }

    _initSessionState() {
      const stored = sessionStorage.getItem(STORAGE_KEY);

      if (stored) {
        this._state = JSON.parse(stored);
        this._state.last_tick_time = Date.now();
        this._persistState();
        this._clevertapEventData = {
          "Customer Name": this._state.customer_name,
          "Customer Email": this._state.customer_email,
          "Customer Phone": this._state.customer_phone,
          "Coupon Code": this._state.coupon_code
        };
        return;
      }

      const hasCustomer = Boolean(this._data.customer_id);

      this._state = {
        total_active_time: 0,
        close_delay_on_swipe_outside_click_sec: this._data.close_delay_on_swipe_outside_click_sec,
        product_added_to_cart: false,
        last_tick_time: Date.now(),
        sessions_completed: 0,
        current_session: 1,
        popup_shown_count: 0,
        popup_shown_to_customer: false,
        copy_click_count: 0,
        close_click_count: 0,
        user_clicked_copy: false,
        user_clicked_close: false,
        coupon_code: this._data.coupon_code,
        customer_id: hasCustomer ? this._data.customer_id : 'NA',
        customer_email: hasCustomer ? this._data.customer_email : 'NA',
        customer_name: hasCustomer ? this._data.customer_name : 'NA',
        customer_phone: hasCustomer ? this._data.customer_phone : 'NA'
      };

      this._clevertapEventData = {
        "Customer Name": this._state.customer_name,
        "Customer Email": this._state.customer_email,
        "Customer Phone": this._state.customer_phone,
        "Coupon Code": this._state.coupon_code
      };

      this._persistState();
    }

    _persistState() {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this._state));
    }

    _startSessionInterval() {
      if(this._state.product_added_to_cart) return;
      this._sessionInterval = setInterval(() => this._tickSessionTime(), 1000);
    }

    _tickSessionTime() {
      const now = Date.now();
      const delta = Math.floor((now - this._state.last_tick_time) / 1000);
      if (delta <= 0) return;

      this._state.total_active_time += delta;
      this._state.last_tick_time = now;

      if (this._state.total_active_time >= this._data.session_duration) {
        this._state.sessions_completed += 1;
        this._state.current_session = this._state.sessions_completed + 1;
        this._state.total_active_time = 0;
        this._persistState();
        this._handleSessionEntry();
      } else {
        this._persistState();
      }
    }

    _handleSessionEntry() {
      if (this._state.popup_shown_to_customer) {
        if (this._sessionInterval !== null) {
          clearInterval(this._sessionInterval);
          this._sessionInterval = null;
        }
        return
      };
      if (!this._data.coupon_code) return;

      if (!this._data.customer_id) {
        this._schedulePopup();
        return;
      }

      if (!this._data.verify_url) return;
      this._verifyCustomer();
    }

    async _verifyCustomer() {
      try {
        const res = await fetch(this._data.verify_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customerId: this._data.customer_id,
            discountCode: this._data.coupon_code
          })
        });

        if (!res.ok) {
          if (this._sessionInterval !== null) {
            clearInterval(this._sessionInterval);
            this._sessionInterval = null;
          }
          return;
        }
        const json = await res.json();
        if (json?.valid === true) {
          this._schedulePopup();
        }
      } catch (_) {}
    }

    _schedulePopup() {
      if (this._isOpen) return;
      this.show();
    }

    show() {
      if (this._isOpen) return;
      if (!this._interactionListenersAttached && this._data.close_delay_on_swipe_outside_click_sec >= 0) {
        this._interactionListenersAttached = true;
        this._delayedInteractionListenerTimer = setTimeout(() => {
          if (!this.isConnected) return;
          this._overlay.addEventListener('click', this._onOverlayClick);
          this._panel.addEventListener('touchstart', this._onTouchStart, { passive: true });
          this._panel.addEventListener('touchend', this._onTouchEnd, { passive: true });
          if(this._swipeIndicator && !this._swipeIndicator.classList.contains('show-scp-swipe-indicator')) {
            this._swipeIndicator.classList.add('show-scp-swipe-indicator');
          }
        }, this._data.close_delay_on_swipe_outside_click_sec * 1000);
      }

      this._previousActiveElement = document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

      this._isOpen = true;
      this._state.popup_shown_count += 1;
      this._state.popup_shown_to_customer = true;
      this._persistState();

      this._overlay.hidden = false;
      this._overlay.inert = false;

      requestAnimationFrame(() => {
        this._overlay.classList.add('is-open');
        this._overlay.removeAttribute('aria-hidden');
        this._closeBtn?.focus();
      });

      document.addEventListener('keydown', this._onKeydown);
      if (window.clevertap?.event) {
        try {
          clevertap.event.push("Sale Popup Triggered", this._clevertapEventData);
        } catch (_) {}
      }
      if (this._data.auto_hide > 0) {
        this._autoHideTimer = setTimeout(() => this.close(), this._data.auto_hide * 1000);
      }
    }

    close() {
      if (!this._isOpen) return;

      if (this._copyBtn?.classList.contains('is-copied')) {
        this._copyBtn.classList.remove('is-copied');
      }

      if (this._copyResetTimer) {
        clearTimeout(this._copyResetTimer);
        this._copyResetTimer = null;
      }

      if (
        this._previousActiveElement &&
        !this.contains(this._previousActiveElement)
      ) {
        this._previousActiveElement.focus();
      } else {
        document.body.focus();
      }

      const scpData = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      if (window.clevertap?.event) {
        try {
          clevertap.event.push("Sale Popup Closed", this._clevertapEventData);
        } catch (_) {}
      }

      this._state.user_clicked_copy = false;
      this._state.user_clicked_close = false;
      this._persistState();

      this._isOpen = false;
      this._clearPopupTimers();

      this._overlay.inert = true;
      this._overlay.classList.remove('is-open');

      requestAnimationFrame(() => {
        this._overlay.setAttribute('aria-hidden', 'true');
        this._overlay.hidden = true;
      });

      document.removeEventListener('keydown', this._onKeydown);
    }

    _clearPopupTimers() {
      if (this._autoHideTimer) clearTimeout(this._autoHideTimer);
      this._autoHideTimer = null;
    }

    _onOverlayClick(e) {
      if (!this._panel.contains(e.target)) this.close();
    }

    _onCloseClick(e) {
      e.preventDefault();
      this._state.user_clicked_close = true;
      this._state.close_click_count += 1;
      this._persistState();
      this.close();
    }

    async _onCopyClick() {
      if (!this._couponEl || !this._copyBtn) return;
      const clevertapEventData = this._clevertapEventData;
      try {
        await navigator.clipboard.writeText(
          this._couponEl.textContent.trim()
        );
        this._state.user_clicked_copy = true;
        this._state.copy_click_count += 1;
        this._persistState();

        this._copyBtn.classList.add('is-copied');
        this._copyResetTimer = setTimeout(() => {
          this._copyBtn.classList.remove('is-copied');
        }, 2500);
        if (window.clevertap?.event) {
          clevertap.event.push("Sale Code Copied", clevertapEventData);
        }
      } catch (_) {}
    }

    _onKeydown(e) {
      if (e.key === 'Escape') this.close();
    }

    _onTransitionEnd() {
      if (!this._isOpen) {
        this._overlay.hidden = true;
      }
    }

    _onTouchStart(e) {
      const t = e.touches[0];
      this._touchStartY = t.clientY;
      this._touchStartX = t.clientX;
    }

    _onTouchEnd(e) {
      const t = e.changedTouches[0];
      const deltaY = t.clientY - this._touchStartY;
      const deltaX = Math.abs(t.clientX - this._touchStartX);
      if (deltaY > 80 && deltaY > deltaX) this.close();
    }
  }

  customElements.define('sale-coupon-popup', SaleCouponPopup);
})();
